import { z } from 'zod'

export default z.object({
  __typename: z.literal('CallItem').default('CallItem'),
  id: z.string(),
})
